exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-contenteditable[data-v-58fc4246]{min-width:0;width:100%}.fts-automation-contenteditable .automation-contenteditable[data-v-58fc4246]{display:flex;align-items:center}.fts-automation-contenteditable .automation-contenteditable-control[data-v-58fc4246]{width:auto}.fts-automation-contenteditable .automation-contenteditable-action[data-v-58fc4246]{margin-left:.375rem;color:var(--fts-form-control-placeholder);cursor:pointer}", ""]);

// exports
